import {
  fetchProductsList,
  fetchProductsListV2,
} from '../../../api/marketplace'
import { fetchAzureProductsList } from '../../../api/azure'
import { fetchGcpProductsList } from '../../../api/gcp'
import { CloudMarketplace } from '../types'

export const getProductsListByCloud = (
  partnerId: string,
  cloud: CloudMarketplace,
  include?: string
) => {
  switch (cloud) {
    case 'AWS':
      return fetchProductsList(partnerId as string, include)
    case 'AZURE':
      return fetchAzureProductsList(partnerId)
    case 'GCP':
      return fetchGcpProductsList(partnerId)
    default:
      return fetchProductsList(partnerId)
  }
}

export const getProductsListV2ByCloud = (
  partnerId: string,
  cloud: CloudMarketplace,
  include?: string,
  pageSize?: number,
  pageNumber?: number
) => {
  switch (cloud) {
    case 'AWS':
      return fetchProductsListV2(partnerId, include, pageSize, pageNumber)
    case 'AZURE':
      return fetchAzureProductsList(partnerId)
    case 'GCP':
      return fetchGcpProductsList(partnerId)
    default:
      return fetchProductsListV2(partnerId, include, pageSize, pageNumber)
  }
}

export const getFlyOutProductFormDataByCloudBase = async ({
  accountId,
  productId,
  cloudMarketplace,
}: {
  accountId: string
  productId: string
  cloudMarketplace: CloudMarketplace
}) => {
  switch (cloudMarketplace) {
    case 'AWS':
      return fetchProductsList(accountId, '', undefined, undefined, productId)
    default:
      return
  }
}
